module.exports = __webpack_public_path__ + "static/media/education-icon.3592ebd0.svg";